/**
 * 礼物兑换
 */

define(function(require, exports, module) {

    const Base = require('c-base');
    const native = require('c-up-native');
    const UserAct = require('../base/useract');
    var taskTpl = require('./task.tmpl');

    var getErrConfig = require('./error_config');

    var GalaPop = require('../../lib/normalPop');

    const TaskComponent = Base.extend({
        defaults: {
            wrap: '#task-bolck',
            taskTpl: taskTpl,
            exchangeCount: 0,
            userToken:''
        },

        initialize() {
            let self = this;
            self.Parent.apply(self, arguments);
            this.nodeWrap = $(this.get('wrap'));
        },
        render(){
            let self = this;
            this.on('getActInfo',function(data){
                let html = taskTpl({
                    taskActInfo: data
                });
                
                this.nodeWrap.append(html);
                self.bindEvent();

            })
            this.loadActData();
        },
        loadActData(){
            let userAct = new UserAct({
                activityId:UpAct.CONFIG.getTaskActId(),
                userToken:this.get('userToken')
            });
            let promise = userAct.getUserActInfo();

            promise.done((data)=>{
                UpAct.taskActInfo = data;
                this.emit('getActInfo',data);
            });
        },

        bindEvent() {

            var self = this;
            $('[node-id="reward-task"]',this.nodeWrap).on('click',function(e){
                let target = e.currentTarget;
                let acid = $(target).data('acid');
                let toreward = $(target).data('toreward');

                if(toreward > 0){
                    self.handleClick(acid);
                }
            });
        },

        handleClick(acid) {

            let self = this;
            let taskActInfo = UpAct.taskActInfo[acid];
            // if(taskActInfo.serverTime > taskActInfo.endTime ){
            //     let content = UpAct.lang.template('不在活动时间范围内');
            //     return self.tipForExchange(content);
            // }
            if(taskActInfo.rewardList.toreward > 0){
                self.guidToExchange(acid,taskActInfo.rewardList.toreward);
            } else {
                let content = UpAct.lang.template('不可领取提示');
                self.tipForExchange(content);
            }
        },
        guidToExchange(acid,count){

            let self = this;

            let pop = new GalaPop({
                //title: UpAct.lang.template('活动规则'),
                context: `<span>${UpAct.lang.template("可领取提示{count}",{count:count})}</span>`,
                btnContext: `<div class="gala-pop-btn" node-id="okBtn">
                        ${UpAct.lang.template('领取')}
                    </div>`,
                onCreate: (el,popup,gala)=>{
                    el.addClass('widget-poplayer-alert');
                    el.delegate('[node-id="okBtn"]','click',()=>{
                        UpAct.loading.show();
                        self.handleExchange(acid);
                        pop.close();
                    });
                }
            });

            pop.create();

        },
        tipForExchange(content){

            let self = this;

            let pop = new GalaPop({
                context: content,
                onCreate: (el,popup,gala)=>{
                    el.addClass('widget-poplayer-alert');
                }
            });

            pop.create();

        },

        tipForExchangeSuccess(content){

            let self = this;

            let pop = new GalaPop({
                //title: UpAct.lang.template('活动规则'),
                context: content,
                btnContext: `<div class="gala-pop-btn" node-id="okBtn">
                        ${UpAct.lang.template('确定')}
                    </div>`,
                onCreate: (el,popup,gala)=>{
                    el.addClass('widget-poplayer-alert');
                    el.delegate('[node-id="okBtn"]','click',()=>{
                        pop.close();
                        window.location.reload();
                    });
                },
                onClose: (el)=>{
                }
            });

            pop.create();

        },
        handleExchange(acid){
            let self = this;
            if (this.submitting) {
                return;
            }
            this.submitting = true;

            UpAct.loading.show();
            let userAct = new UserAct({
                    activityId:acid,
                    userToken:this.get('userToken')
                });
            let promise = userAct.doExchange();
            promise.done((res)=>{
                self.submitting = false;
                UpAct.loading.hide();
                let content = UpAct.lang.template('领取成功提示');
                self.tipForExchangeSuccess(content);
            });
            promise.fail((res)=>{
                self.submitting = false;
                UpAct.loading.hide();

                let errInfo = getErrConfig(res.errcode);

                let content = UpAct.lang.template( errInfo.tip );

                self.tipForExchange(content,errInfo.type);
            })
        },

        
    });

    module.exports = TaskComponent;

    UpAct.TaskComponent = TaskComponent;
});



// WEBPACK FOOTER //
// ./js/component/task/index.js